import { useState, useEffect } from "react";

const PlanForm = ({ onSubmit, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    price: "",
    totalSessions: "",
    sessionDurationMinutes: "",
    planType: "GROUP",
    isFree: false,
    isActive: true,
    sessionsGroup: "",
    sessionsGroupDiscussion: "",
    sessionsOneOnOne: "",
  });

  // Reset session fields when plan type changes
  useEffect(() => {
    if (formData.planType !== "COMBO") {
      setFormData((prev) => ({
        ...prev,
        sessionsGroup: prev.planType === "GROUP" ? prev.totalSessions : "",
        sessionsGroupDiscussion: prev.planType === "GROUP_DISCUSSION" ? prev.totalSessions : "",
        sessionsOneOnOne: prev.planType === "ONE_ON_ONE" ? prev.totalSessions : "",
      }));
    }
  }, [formData.planType, formData.totalSessions]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
      ...(name === "isFree" && checked ? { price: 0 } : {}),
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validation for combo plan
    if (formData.planType === "COMBO") {
      const hasSession =
        Number(formData.sessionsGroup || 0) > 0 ||
        Number(formData.sessionsGroupDiscussion || 0) > 0 ||
        Number(formData.sessionsOneOnOne || 0) > 0;

      if (!hasSession) {
        alert("Combo plan must have at least one session > 0");
        return;
      }
    }

    onSubmit({
      ...formData,
      price: Number(formData.price),
      totalSessions: Number(formData.totalSessions),
      sessionDurationMinutes: Number(formData.sessionDurationMinutes),
      sessionsGroup: Number(formData.sessionsGroup || 0),
      sessionsGroupDiscussion: Number(formData.sessionsGroupDiscussion || 0),
      sessionsOneOnOne: Number(formData.sessionsOneOnOne || 0),
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3>Add Subscription Plan</h3>

      {/* Plan Name */}
      <label>Plan Name</label>
      <input
        name="name"
        placeholder="e.g. Fluency Builder"
        value={formData.name}
        onChange={handleChange}
        required
      />

      {/* Description */}
      <label>Description</label>
      <input
        name="description"
        placeholder="e.g. 5 group sessions"
        value={formData.description}
        onChange={handleChange}
      />

      {/* Price */}
      <label>Price (₹)</label>
      <input
        type="number"
        name="price"
        placeholder="e.g. 249"
        value={formData.price}
        onChange={handleChange}
        disabled={formData.isFree || formData.planType === "COMBO"}
        required={!formData.isFree}
      />

      {/* Session Duration */}
      <label>Session Duration (minutes)</label>
      <input
        type="number"
        name="sessionDurationMinutes"
        placeholder="e.g. 30"
        value={formData.sessionDurationMinutes}
        onChange={handleChange}
        required
      />

      {/* Plan Type */}
      <label>Plan Type</label>
      <select
        name="planType"
        value={formData.planType}
        onChange={handleChange}
      >
        <option value="ONE_ON_ONE">One-on-One</option>
        <option value="GROUP">Group</option>
        <option value="GROUP_DISCUSSION">Group Discussion</option>
        <option value="COMBO">Combo</option>
      </select>

      {/* Single plan session input */}
      {formData.planType !== "COMBO" && (
        <div style={{ marginTop: "1rem" }}>
          {formData.planType === "GROUP" && (
            <>
              <label>Sessions - Group</label>
              <input
                type="number"
                name="sessionsGroup"
                value={formData.sessionsGroup}
                onChange={handleChange}
              />
            </>
          )}
          {formData.planType === "GROUP_DISCUSSION" && (
            <>
              <label>Sessions - Group Discussion</label>
              <input
                type="number"
                name="sessionsGroupDiscussion"
                value={formData.sessionsGroupDiscussion}
                onChange={handleChange}
              />
            </>
          )}
          {formData.planType === "ONE_ON_ONE" && (
            <>
              <label>Sessions - One-on-One</label>
              <input
                type="number"
                name="sessionsOneOnOne"
                value={formData.sessionsOneOnOne}
                onChange={handleChange}
              />
            </>
          )}
        </div>
      )}

      {/* Combo Session Counts */}
      {formData.planType === "COMBO" && (
        <div style={{ marginTop: "1rem" }}>
          <label>Sessions - Group</label>
          <input
            type="number"
            name="sessionsGroup"
            value={formData.sessionsGroup}
            onChange={handleChange}
          />

          <label>Sessions - Group Discussion</label>
          <input
            type="number"
            name="sessionsGroupDiscussion"
            value={formData.sessionsGroupDiscussion}
            onChange={handleChange}
          />

          <label>Sessions - One-on-One</label>
          <input
            type="number"
            name="sessionsOneOnOne"
            value={formData.sessionsOneOnOne}
            onChange={handleChange}
          />
        </div>
      )}

      {/* Is Free */}
      <label style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
        <input
          type="checkbox"
          name="isFree"
          checked={formData.isFree}
          onChange={handleChange}
        />
        Is Free Plan
      </label>

      {/* Actions */}
      <div className="form-actions">
        <button type="submit">Save Plan</button>
        <button type="button" onClick={onClose}>
          Cancel
        </button>
      </div>
    </form>
  );
};

export default PlanForm;
